<hpf-module-en-savoir-plus-form
	*ngIf="moduleEnSavoirPlus"
	[moduleEnSavoirPlus]="moduleEnSavoirPlus"
	(create)="onCreate($event)"
></hpf-module-en-savoir-plus-form>
<div *ngIf="!moduleEnSavoirPlus" class="my-5 text-center">
	<nz-spin nzSimple></nz-spin>
</div>
